import type { Platform } from '../core/keymap'

/** The keymap column of the running platform; iOS and Mac report Meta as `Mod`. */
export function viewPlatform(): Platform {
  if (/iPod|iPhone|iPad/.test(navigator.platform)) return 'ios'
  if (navigator.platform.includes('Mac')) return 'mac'
  return navigator.userAgent.includes('Android') ? 'android' : 'pc'
}
